import { connect } from "react-redux";
import MyInformations from "app/pages/Booking/MyInformations/MyInformations.jsx";
import { getContextCallCenter } from "app/pages/Booking/bookingSelectors";

const mapStateToProps = state => {
	const { dvaf } = state.documents; // { FA: {..}, AO: {...} }
	const contextCallCenter = getContextCallCenter({})(state);
	const offerType = state.booking.offer.type; // FA | AO

	return {
		dvaf: dvaf[offerType] ? dvaf[offerType] : undefined,
		ficheProduitURI: state.ficheProduit.uri,
		email: contextCallCenter.email,
		phone: contextCallCenter.dialPhone,
		shop: state.shop,
	};
};

export default connect(mapStateToProps)(MyInformations);
